import { render, staticRenderFns } from "./CalendarPageContentDayKanban.vue?vue&type=template&id=78b06542&scoped=true"
import script from "./CalendarPageContentDayKanban.vue?vue&type=script&lang=js"
export * from "./CalendarPageContentDayKanban.vue?vue&type=script&lang=js"
import style0 from "./CalendarPageContentDayKanban.vue?vue&type=style&index=0&id=78b06542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b06542",
  null
  
)

export default component.exports